module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ym-layout', [_c('div', {
    attrs: {
      "slot": "bgimg"
    },
    slot: "bgimg"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-carousel', {
    attrs: {
      "height": "384px",
      "arrow": "never"
    }
  }, [_c('el-carousel-item', {
    staticClass: "adindex"
  }, [_c('ul', {
    staticClass: "ad1"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/welcome1.jpg")
    }
  })])])]), _vm._v(" "), _c('el-carousel-item', {
    staticClass: "adindex"
  }, [_c('ul', {
    staticClass: "ad2"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/welcome2.png")
    }
  })])])]), _vm._v(" "), _c('el-carousel-item', {
    staticClass: "adindex"
  }, [_c('ul', {
    staticClass: "ad3"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/welcome3.png")
    }
  })])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wauto bgfff hauto"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "supply txtcenter"
  }, [_c('h1', {
    staticClass: "green"
  }, [_vm._v("供应信息")]), _vm._v(" "), _c('p', {
    staticClass: "margintop15"
  }, [_vm._v("木材原料种类齐全，来自全球各地的原木、锯材、人造板、木皮，木制品"), _c('br'), _vm._v("有木头专注经营木材上游到下游")]), _vm._v(" "), _c('div', {
    staticClass: "supplyList"
  }, [_c('div', {
    staticClass: "supplyOne pr"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/s1.jpg"),
      "width": "288"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pa info none"
  }, [_vm._v("森林/原木")])]), _vm._v(" "), _c('div', {
    staticClass: "supplyOne pr"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/s2.jpg"),
      "width": "288"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pa info none"
  }, [_vm._v("锯材/工程用料")])]), _vm._v(" "), _c('div', {
    staticClass: "supplyOne pr"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/s3.jpg"),
      "width": "288"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pa info none"
  }, [_vm._v("人造板")])]), _vm._v(" "), _c('div', {
    staticClass: "supplyOne pr"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/s4.jpg"),
      "width": "288"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pa info none"
  }, [_vm._v("木皮/单板")])]), _vm._v(" "), _c('div', {
    staticClass: "supplyOne pr"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/s5.jpg"),
      "width": "288"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pa info none"
  }, [_vm._v("托盘/包装材")])]), _vm._v(" "), _c('div', {
    staticClass: "supplyOne pr"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/s6.jpg"),
      "width": "288"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pa info none"
  }, [_vm._v("尾料")])]), _vm._v(" "), _c('div', {
    staticClass: "supplyOne pr"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/s7.jpg"),
      "width": "288"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pa info none"
  }, [_vm._v("木工机械")])]), _vm._v(" "), _c('div', {
    staticClass: "supplyOne pr intomall"
  }, [_c('router-link', {
    staticClass: "pa green",
    attrs: {
      "to": {
        name: '002-1'
      }
    }
  }, [_vm._v("\n                            前往现货商城\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "ico-index goto pa"
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "container futures"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/map.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "statistics right"
  }, [_c('div', {
    staticClass: "one left pr"
  }, [_c('div', {
    staticClass: "total txtcenter"
  }, [_c('strong', [_vm._v("80")]), _vm._v("+"), _c('span', [_vm._v("国家")])]), _vm._v(" "), _c('p', {
    staticClass: "green txtcenter"
  }, [_vm._v("采购地区遍布全球"), _c('br'), _vm._v("八十多个国家")]), _vm._v(" "), _c('div', {
    staticClass: "pa ico-index sanjiao"
  })]), _vm._v(" "), _c('div', {
    staticClass: "one left pr"
  }, [_c('div', {
    staticClass: "total txtcenter"
  }, [_c('strong', [_vm._v("10000")]), _vm._v("+"), _c('span', [_vm._v("木材厂商")])]), _vm._v(" "), _c('p', {
    staticClass: "green txtcenter"
  }, [_vm._v("全年木材采购量"), _c('br'), _vm._v("达到一亿立方")]), _vm._v(" "), _c('div', {
    staticClass: "pa ico-index sanjiao"
  })]), _vm._v(" "), _c('div', {
    staticClass: "goto"
  }, [_vm._v("\n                来自各国木材生产商最新期货数据\n\n\n\n                "), _c('router-link', {
    staticClass: "green",
    attrs: {
      "to": {
        name: '003-1'
      }
    }
  }, [_vm._v("\n                    去看看！\n\n\n\n                ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wauto bgfff hauto muma ",
    staticStyle: {
      "background": "#FFFFFF",
      "height": "auto",
      "padding": "110px 0 88px 0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('dl', {
    staticClass: "wauto left"
  }, [_c('dt', {
    staticClass: "color000"
  }, [_vm._v("信息化仓储物流管理")]), _vm._v(" "), _c('dd', [_vm._v("\n                    仓库分布在国内木材市场集中的城市，对木材供应商、木材加工商、家具制造商开放全方位合作空间；木马物流为供需双方提供线上找车服务，让找车更简单，发货更容易，物流成本更低。结合信息化、数字化技术开启科学、人性化物流管理。\n\n\n\n                ")]), _vm._v(" "), _c('dd', [_c('a', {
    staticClass: "left txtcenter green"
  }, [_c('span', {
    staticClass: "ico-index cc"
  }), _vm._v("\n                        有木仓储\n                    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "left txtcenter green",
    attrs: {
      "to": {
        name: '004-3'
      }
    }
  }, [_c('span', {
    staticClass: "ico-index wl"
  }), _vm._v("\n                        木马物流\n\n\n\n                    ")]), _vm._v(" "), _c('a', {
    staticClass: "left txtcenter green"
  }, [_c('span', {
    staticClass: "ico-index xt"
  }), _vm._v("\n                        ERP系统\n                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wauto right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ck.jpg"),
      "width": "407",
      "height": "312",
      "alt": "信息化仓储物流管理"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container finance hauto"
  }, [_c('div', {
    staticClass: "wauto left intro"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": require("../assets/images/jr2.png"),
      "width": "200",
      "height": "206",
      "alt": "有木金融,木材金融"
    }
  }), _vm._v(" "), _c('dl', {
    staticClass: "left hauto"
  }, [_c('dt', {
    staticClass: "color000"
  }, [_vm._v("有木金融")]), _vm._v(" "), _c('dd', {
    staticClass: "hauto"
  }, [_vm._v("木材行业的专属金融，为有木头会员提供资金支持服务。利息低，可质押，可信贷；放款速度快，满足及时的资金到账需求；省时省心，做您的强大背后支持。\n\n\n\n                    "), _c('router-link', {
    staticClass: "green underline",
    attrs: {
      "to": {
        name: '004-2'
      },
      "target": "_blank"
    }
  }, [_vm._v("\n                        了解更多\n\n\n\n                    ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wauto hauto right list",
    staticStyle: {
      "height": "auto",
      "border": "0px",
      "width": "auto"
    }
  }, [_c('dl', {
    staticClass: "left pr bbf"
  }, [_c('dt', {
    staticClass: "green"
  }, [_vm._v("现货动态质押贷款")]), _vm._v(" "), _c('dd', [_vm._v("1000W~3000W")]), _vm._v(" "), _c('dd', {
    staticClass: "one f1 pa"
  })]), _vm._v(" "), _c('dl', {
    staticClass: "left pr bbf"
  }, [_c('dt', {
    staticClass: "green"
  }, [_vm._v("进口融资代付T/T L/C")]), _vm._v(" "), _c('dd', [_vm._v("20W~1000W")]), _vm._v(" "), _c('dd', {
    staticClass: "one f2 pa"
  })]), _vm._v(" "), _c('dl', {
    staticClass: "left pr bbf"
  }, [_c('dt', {
    staticClass: "green"
  }, [_vm._v("信用贷款")]), _vm._v(" "), _c('dd', [_vm._v("2W~100W")]), _vm._v(" "), _c('dd', {
    staticClass: "one f3 pa"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "wauto app"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "banner hauto"
  }, [_c('div', {
    staticClass: "cartoon left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/cartoon.png"),
      "width": "223",
      "height": "355"
    }
  })]), _vm._v(" "), _c('dl', {
    staticClass: "appabout right hauto"
  }, [_c('dt', {
    staticClass: "color000"
  }, [_vm._v("手机在手，机会不愁！")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "appone left bgfff txtcenter"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/code1.jpg"),
      "width": "116",
      "height": "116"
    }
  }), _vm._v(" "), _c('dl', [_c('dt', {
    staticClass: "green"
  }, [_vm._v("有木头公众号")]), _vm._v(" "), _c('dd', [_vm._v("随时随地，订货卖货")])])]), _vm._v(" "), _c('div', {
    staticClass: "appone left bgfff txtcenter"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo/xiao_shop.jpg"),
      "width": "116",
      "height": "116"
    }
  }), _vm._v(" "), _c('dl', [_c('dt', {
    staticClass: "green"
  }, [_vm._v("有木头小程序")]), _vm._v(" "), _c('dd', [_vm._v("一机在手，方便快捷")])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-40131c78"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/pages/welcome.vue
// module id = 460
// module chunks = 0